import { styled } from "@mui/material/styles";
import {
  Box,
  Stack,
  Typography,
  FormControlLabel,
  Checkbox,
  Backdrop,
} from "@mui/material";
import { TaskAltOutlined } from "@mui/icons-material";

export const RootBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
}));

export const HeaderStack = styled(Stack, {
  shouldForwardProp: (prop) => prop !== "$hasTodaysLesson",
})(({ theme, $hasTodaysLesson }) => ({
  marginBottom: $hasTodaysLesson ? 0 : theme.spacing(2),
  justifyContent: "space-between",
  alignItems: "center",
}));

export const Heading = styled(Typography)(({ theme }) => ({
  ...theme.heading2,
  [theme.breakpoints.down(1050)]: {
    fontSize: "1.2rem",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "1rem",
  },
}));

export const AccessLink = styled(Typography)(({ theme }) => ({
  ...theme.body2,
  color: theme.palette.text.primary,
  fontFamily: "'Quicksand', sans-serif",
  textDecoration: "underline",
  cursor: "pointer",
  "&:hover": {
    cursor: "pointer",
  },
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));

export const CheckboxWrapper = styled(FormControlLabel)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  marginTop: theme.spacing(1),
}));

export const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  color: theme.palette.text.primary,
  "& .MuiSvgIcon-root": {
    color: theme.palette.text.primary,
  },
}));

export const CheckboxIconUnchecked = styled(TaskAltOutlined)(({ theme }) => ({
  color: theme.palette.text.primary,
  opacity: 0.3,
}));

export const CheckboxIconChecked = styled(TaskAltOutlined)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const CheckboxLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  fontSize: "14px",
  fontFamily: "'Quicksand', sans-serif",
}));

export const ContentBox = styled(Box)(({ theme }) => ({
  backgroundColor: "rgba(255,255,255, 0.25)",
  borderRadius: "10px",
  padding: theme.spacing(1),
  overflowY: "auto",
  height: "80vh",
  boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
  "&::-webkit-scrollbar": {
    width: "8px",
  },
  "&::-webkit-scrollbar-track": {
    background: "#f1f1f1",
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#4b5146",
    borderRadius: "10px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#d4a017",
  },
}));

export const ContentText = styled(Typography)(({ theme }) => ({
  ...theme.body,
  marginTop: theme.spacing(1),
  color: theme.palette.text.primary,
  fontFamily: "'Quicksand', sans-serif",
}));

export const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  color: "#fff",
  zIndex: theme.zIndex.drawer + 1,
}));

export const ContentGrid = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  [theme.breakpoints.down(750)]: {
    flexDirection: "column",
  },
}));
